<script lang="ts">
	//UI

	//Image
	import plusBtn from "@hitit/hub/src/assets/Icons/plusBtn.png";
	//Utils
	import { t, api, notifications } from "@hitit/hub/src/stores";
	//Type

	let value = "";
</script>

<div class="container card" t-id="RecordTab">
	추후 개발 예정입니다.
	<!-- 추후 api 개발후 ql-editor로 개발 -->
	<!-- <div class="ql-editor">
		<input
			bind:value={value}
			placeholder="해당 결제에 대한 이력 및 특이사항 작성"
		/>
	</div>
	<div class="record-add-box" on:click={() => confirm("api 필요")}>
		<img src={plusBtn} alt="plus" /><span>{$t("hub.order.record_add")}</span>
	</div> -->
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: 10px;
		width: 100%;
		height: 100px;
		border-radius: 5px;
		background-color: white;

		.ql-editor {
			width: 100%;
			padding: 10px;
		}
		input {
			all: unset;
			width: 100%;
			height: 80px;
			background-color: white;

			::placeholder {
				@include appleAdjustTextForSize(16, false);
				color: #bcbfc3;
			}
		}
		.record-add-box {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 30px;
			border: 1px solid #bcbfc3;
			border-radius: 5px;
			background-color: #e6e7ed;
			gap: 10px;
			cursor: pointer;

			span {
				@include appleAdjustTextForSize(16);
				@include heightRelativeToFontSize(16);
				font-weight: 400;
				color: #6d6f76;
			}

			img {
				width: 20px;
				height: 20px;
			}
		}
	}
	@include DesktopSize {
		.container {
			display: flex;
			align-items: center;
			gap: 20px;
			width: 100%;
			border-radius: 5px;
			input {
				all: unset;
				width: 100%;
				height: 64px;
				background-color: white;

				::placeholder {
					@include appleAdjustTextForSize(16, false);
					color: #bcbfc3;
				}
			}
			.record-add-box {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 100%;
				height: 40px;
				border: 1px solid #bcbfc3;
				border-radius: 5px;
				background-color: #e6e7ed;
				gap: 10px;
				cursor: pointer;

				span {
					@include appleAdjustTextForSize(16, false);
					@include heightRelativeToFontSize(20);
					font-weight: 400;
					color: #6d6f76;
				}

				img {
					width: 20px;
					height: 20px;
				}
			}
		}
	}
</style>
